import { Lightbulb } from "@phosphor-icons/react";
import { guideSteps } from "@/lib/importGuides";

export function ImportGuideSteps({ guide, common }) {
  const steps = guideSteps(guide, common);
  return (
    <div data-testid={`import-guide-${guide.key}`}>
      <p className="text-sm text-slate-600 mb-4">You'll need: <b>{guide.files}</b></p>
      <ol className="space-y-4" data-testid="import-guide-steps">
        {steps.map((s, i) => (
          <li key={i} className="flex gap-3">
            <span className="shrink-0 w-7 h-7 rounded-full bg-rf-orange text-white text-sm font-bold flex items-center justify-center">{i + 1}</span>
            <div>{s.title && <p className="font-semibold text-slate-800">{s.title}</p>}<p className="text-sm text-slate-600 mt-0.5">{s.body}</p></div>
          </li>
        ))}
      </ol>
      {guide.tips?.length > 0 && (
        <div className="mt-5 rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-slate-700" data-testid="import-guide-tips">
          <p className="font-semibold flex items-center gap-1 mb-1"><Lightbulb size={16} className="text-rf-orange" /> Good to know</p>
          <ul className="list-disc pl-5 space-y-1">{guide.tips.map((t) => <li key={t}>{t}</li>)}</ul>
        </div>
      )}
    </div>
  );
}
